<div class="flex flex-col gap-4">
  <div class="flex flex-col gap-2" [formGroup]="scheduleGroup()">
    <div class="font-medium">Access schedule</div>
    @for (scheduleDay of scheduleDays; track scheduleDay.key) {
      <div class="flex items-center gap-3" [formGroupName]="scheduleDay.key">
        <mat-checkbox class="w-36 shrink-0" formControlName="enabled">
          {{ scheduleDay.label }}
        </mat-checkbox>
        <pt-iso-time-selector
          class="min-w-0 flex-1"
          label="From"
          floatLabel="always"
          formControlName="from"
        />
        <pt-iso-time-selector
          class="min-w-0 flex-1"
          label="To"
          floatLabel="always"
          formControlName="to"
        />
      </div>
    }

    @if (scheduleError$ | async; as scheduleError) {
      <span class="mat-caption text-warn-500">{{ scheduleError }}</span>
    } @else {
      <span class="mat-caption text-slate-500">
        Staff can only access on enabled days within each day's window.
      </span>
    }
  </div>
  <mat-divider />
  <div class="flex flex-col gap-2" [formGroup]="ipOverrideGroup()">
    <div class="pb-2 font-medium">IP override</div>
    <pt-multi-chip-input
      formControlName="whitelist"
      itemName="IP"
      label="Allowed IPs"
      [validatorFn]="isIpValidatorFn"
    >
      <span matHintContent class="text-slate-500">
        Overrides the workspace IP whitelist. Leave empty to use the workspace
        whitelist.
      </span>
    </pt-multi-chip-input>
  </div>
</div>
